
<template>
    <v-menu 
        open-on-hover 
        top 
        offset-y
        v-if="!!filters.get_filter_value('business_process')"
        :disabled="disabled"
    >
        <template v-slot:activator="{ on }">
            <v-btn 
                icon
                v-on="on"
                class="explorer-header-report-list"
                color="primary"
                :medium="!is_mobile" :small="is_mobile"
                :loading="disabled"
            >
                <v-icon :medium="!is_mobile" :small="is_mobile">mdi-file-download-outline</v-icon>
            </v-btn>
        </template>
        <v-list dense>
            <v-list-item
                v-for="[rid, name] in Object.entries(report_list)"
                :key="rid"
                @click.stop="download_report_list(rid, name)"
            >
            <v-list-item-title>{{ name }}</v-list-item-title>
          </v-list-item>
        </v-list>
    </v-menu>    
</template>

<style lang="scss">
 .explorer-header-report-list {
  vertical-align: inherit !important;
 }

</style>

<script>
import QReport from '@/api/QReportsItem'
import { downloadFile } from '@/utils/browserfiles';
import { mapState, mapMutations, mapGetters } from 'vuex';
import { InfoAlert, SuccessAlert, ErrorAlert } from '@/utils/Alerts'


export default {
    name: 'DownloadReportList',

    props: {
        filters: {},
        is_mobile: {type: Boolean, default: false},
    },

    data: () => ({
        report_list: {},
    }),

    mounted() {
        this.get_templates();
    },

    computed: {
      ...mapState(['bpmap','disabled_components']),
      ...mapGetters([
        'sitePath',
        'centro_id',
      ]),
      disabled() {
        return this.disabled_components.report_list;
      },
    },

    methods: {
        ...mapMutations(['SET_DISABLED_COMPONENT','SET_MESSAGE']),

        download_report_list(template_id, name) {

            this.SET_MESSAGE(new InfoAlert(this.$vuetify.lang.translator('reports.info'),5000));
            this.SET_DISABLED_COMPONENT({'report_list': true})
            
            QReport.printList(
                this.centro_id,
                template_id,
                this.filters.get_filter_value('business_process'),
                // this.filters.centro = this.centro_id,
                this.filters.as_query(),
            ).then(data => {
                let f_name = name + '.xlsx';
                // TODO: HARDCODDED xlsx
                downloadFile(data, f_name)

                this.SET_MESSAGE(new SuccessAlert(this.$vuetify.lang.translator('reports.success'),5000));
                this.SET_DISABLED_COMPONENT({'report_list': false});

            }).catch(error => {
                console.error(error)

                this.SET_MESSAGE(new ErrorAlert(this.$vuetify.lang.translator('reports.error')));
                this.SET_DISABLED_COMPONENT({'report_list': false});
            }
            );
        },

        get_templates() {
            if(this.filters.get_filter_value('business_process')) {
                this.report_list = (this.bpmap[this.filters.get_filter_value('business_process')]||{}).list_reports_templates || []
            }
            
                
        },
    },

    watch: {
        filters(now, before) {
            if (now.get_filter_value('business_process') != before.get_filter_value('business_process')) {
                this.get_templates();
            }
        }

    },
}

</script>